document.addEventListener('DOMContentLoaded', () => {
  // ---------------------------
  // External Links warning
  // ---------------------------
  const excludedLinks = [
    'https://www.facebook.com/',
    'https://www.instagram.com/',
    'https://www.tiktok.com/',
  ];

  const isExternalLink = (url) => {
    try {
      const linkHost = new URL(url).hostname;
      const currentHost = window.location.hostname;
      return linkHost && linkHost !== currentHost;
    } catch {
      return false;
    }
  };

  const enhanceExternalLinks = () => {
    const links = document.querySelectorAll('a');
    links.forEach(link => {
      const href = link.getAttribute('href');
      if (
        !href ||
        !isExternalLink(href) ||
        excludedLinks.includes(href) ||
        link.matches('li[data-submenu-parent] > a')
      ) return;

      link.setAttribute('target', '_blank');
      const linkText = link.textContent.trim();
      link.setAttribute('aria-label', `${linkText}, This link will open in a new tab`);

      const img = link.querySelector('img, svg');
      if (img) {
        const altText = img.getAttribute('alt') || '';
        const updatedAlt = altText
          ? `${altText}, This link will open in a new tab`
          : 'This link will open in a new tab';
        img.setAttribute('alt', updatedAlt);
      }
    });
  };

  const enhanceContactLinks = () => {
    const contactLinks = document.querySelectorAll('a[href^="mailto:"], a[href^="tel:"]');
    contactLinks.forEach(link => {
      const href = link.getAttribute('href');
      const linkText = link.textContent.trim();
      if (href.startsWith('mailto:')) {
        link.setAttribute('aria-label', `Email Address: ${linkText}`);
      } else if (href.startsWith('tel:')) {
        link.setAttribute('aria-label', `Phone number: ${linkText}`);
      }
    });
  };

  enhanceExternalLinks();
  enhanceContactLinks();

  // Remove aria-labels on specific links
  document.querySelectorAll('a.meganav-promoted-collections-item')
    .forEach(el => el.removeAttribute('aria-label'));

  document.querySelectorAll('h2.section-blocks__heading.heading-block.ff-heading.fs-heading-1-base').forEach(h2 => {
  const p = document.createElement('p');
  p.innerHTML = h2.innerHTML;
  [...h2.attributes].forEach(attr => p.setAttribute(attr.name, attr.value));
  h2.parentNode.replaceChild(p, h2);
});

document.querySelectorAll('h3#similarColorsTitle').forEach(h3 => {
  const p = document.createElement('p');
  p.innerHTML = h3.innerHTML;
  [...h3.attributes].forEach(attr => p.setAttribute(attr.name, attr.value));
  h3.parentNode.replaceChild(p, h3);
});

document.querySelectorAll('a.navigation__submenu-trigger.no-transition.fs-navigation-base')
  .forEach(trigger => {
    ['click', 'focus'].forEach(evt => {
      trigger.addEventListener(evt, () => {
        document.querySelectorAll('li.navigation__submenu-item.animation--dropdown-item a')
          .forEach(el => el.removeAttribute('aria-expanded'));
      });
    });
  });
document.querySelectorAll('.quantity-input-wrapper__labels.product__label.visually-hidden')
  .forEach(el => el.setAttribute('aria-hidden', 'true'));

  // ---------------------------
  // Basic accessibility fixes
  // ---------------------------
  document.querySelectorAll('br, hr').forEach(el => el.setAttribute('aria-hidden', 'true'));
  document.querySelectorAll('.multi-column__grid-item-image-wrapper')
    .forEach(el => el.removeAttribute('aria-label'));

  setTimeout(() => {
    document.querySelectorAll('button.swym-storefront-layout-action-close-button')
      .forEach(btn => btn.setAttribute('aria-label', 'Close Button'));
  }, 1000);

  setTimeout(() => {
    const el = document.getElementById('swym-storefront-layout-action-tooltip-options');
    if (el) {
      el.removeAttribute('role');
      el.removeAttribute('aria-label');
    }
  }, 1000);

  document.querySelectorAll('h2, h3').forEach(heading => {
    if (!heading.textContent.trim()) heading.remove();
  });

  document.querySelectorAll('.header__nav-bar .header__links > ul > li > [data-link]')
    .forEach(el => {
      const executeLogic = () => {
        document.querySelectorAll('.header__nav-bar .header__links > ul > li > [data-link]')
          .forEach(innerEl => {
            if (!innerEl.closest('li[data-submenu-parent]')) {
              innerEl.removeAttribute('aria-expanded');
            }
          });
      };
      el.addEventListener('click', executeLogic);
      el.addEventListener('focus', executeLogic);
    });

  // ---------------------------
  // Search Modal Accessibility
  // ---------------------------
  const searchContainer = document.querySelector(".quick-search__active-search-container");
  const cancelBtn = document.querySelector(".quick-search__cancel.btn.btn--text");
  const targetFocus = document.querySelector(".quick-search__inner");

  if (searchContainer && cancelBtn && targetFocus) {
    searchContainer.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        targetFocus.setAttribute("tabindex", "-1");
        targetFocus.focus();
      }
    });

    cancelBtn.addEventListener("click", (event) => {
      event.preventDefault();
      targetFocus.setAttribute("tabindex", "-1");
      targetFocus.focus();
    });
  }

  // ---------------------------
  // Accessible Menu
  // ---------------------------
  const menuLinks = document.querySelectorAll('li[data-submenu-parent] > a');
  menuLinks.forEach(link => {
    link.removeAttribute('href');
    link.setAttribute('role', 'button');
    link.setAttribute('tabindex', '0');
    link.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        link.click();
      }
    });
  });

  // ---------------------------
  // Banner Slider Buttons
  // ---------------------------
  const contentBlocks = document.querySelectorAll('.media-with-content__content');
  contentBlocks.forEach(block => {
    const heading = block.querySelector('.section-blocks__heading');
    const button = block.querySelector('.section-blocks__button a');
    if (heading && button) {
      const headingText = heading.textContent.trim();
      const buttonText = button.textContent.trim();
      button.setAttribute('aria-label', `${buttonText}, ${headingText}`);
    }
  });

  // ---------------------------
  // Collection Item Labels
  // ---------------------------
  document.querySelectorAll('.collection-item').forEach(item => {
    const link = item.querySelector('.collection-item__link');
    const title = item.querySelector('.collection-item__title');
    if (link && title) {
      const titleText = title.textContent.trim();
      link.setAttribute('aria-label', `View ${titleText} Collection`);
    }
  });

  // ---------------------------
  // Tabs Setup
  // ---------------------------
  const tabList = document.querySelector('.product-tabs__tab-buttons-wrapper .tab-buttons');
  if (tabList) tabList.setAttribute('role');

  function updateTabs(activeButton) {
    document.querySelectorAll('.tab-buttons__button').forEach(button => {
      const panelId = button.getAttribute('data-shows-collection-key');
      const panel = document.getElementById(panelId);
      if (button === activeButton) {
        button.classList.add('selected');
        button.setAttribute('aria-selected', 'true');
        button.setAttribute('tabindex', '0');
        if (panel) panel.hidden = false;
      } else {
        button.classList.remove('selected');
        button.setAttribute('aria-selected', 'false');
        button.setAttribute('tabindex', '-1');
        if (panel) panel.hidden = true;
      }
    });
  }

  document.querySelectorAll('.tab-buttons__button').forEach((button, index) => {
    button.setAttribute('role', 'tab');
    button.id = `tab-${index}`;
    const panelId = button.getAttribute('data-shows-collection-key');
    if (panelId) {
      button.setAttribute('aria-controls', panelId);
      const panel = document.getElementById(panelId);
      if (panel) {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('tabindex', '0');
      }
    }
    button.addEventListener('click', () => updateTabs(button));
  });

  const selectedButton = document.querySelector('.tab-buttons__button.selected');
  if (selectedButton) {
    updateTabs(selectedButton);
  } else {
    const firstButton = document.querySelector('.tab-buttons__button');
    if (firstButton) updateTabs(firstButton);
  }

  // ---------------------------
  // CTA Aria Labels
  // ---------------------------
  function updateCTAAriaLabel() {
    const headingElement = document.querySelector('.section-header__heading');
    const buttonElement = document.querySelector('.button-wrapper .btn--tertiary');
    if (!headingElement || !buttonElement) return;
    const rawHeadingText = headingElement.textContent || '';
    const cleanedHeadingText = rawHeadingText
      .replace(/[\u00AE\u2122]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
    const buttonText = buttonElement.textContent.trim();
    buttonElement.setAttribute('aria-label', `${buttonText}, ${cleanedHeadingText}`);
  }
  updateCTAAriaLabel();

  // ---------------------------
  // Tab focus behavior
  // ---------------------------
  const tabButtons = document.querySelectorAll('.tab-buttons__button');
  tabButtons.forEach(button => {
    button.addEventListener('click', () => {
      tabButtons.forEach(btn => {
        btn.classList.remove('selected');
        btn.setAttribute('aria-selected', 'false');
        btn.setAttribute('tabindex', '-1');
      });
      button.classList.add('selected');
      button.setAttribute('aria-selected', 'true');
      button.setAttribute('tabindex', '0');
      button.focus();
    });
  });
});